import React, { memo, useEffect, useRef, useState } from 'react';
import './css/style.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';
import ReactPlayer from 'react-player';
import { specialityPopOver, reactHtmlParser } from '../../../common/common';
import ShareCard from '../../ShareCard';
import LazyImage from '../../CustomLibraries/LazyImage';
import useRedirect from '../../customHooks/useRedirect';
import { toast } from 'react-toastify';
import { ProgressBar, Spinner } from 'react-bootstrap';
import InView, { useInView } from 'react-intersection-observer';
import { isMobile } from 'react-device-detect';
import { RiPlayCircleFill } from '../../../components/icons';
import DoctorsSectionForCard from '../../DoctorSectionForCard/DoctorsSectionForCard';
import { useLocation } from 'react-router-dom';
import { clinical_Video_static_image } from '../../../common/assets.common';
import { useTrackUserActivity } from '../../customHooks/useTrackUserActivity';
// install Swiper modules
SwiperCore.use([EffectFade, Autoplay]);

const ClinicalVideoCardV1 = ({
  data = '',
  hideImage = false,
  tabKey = '',
  click,
  gtmTagVariable = ''
}) => {
  const { redirectTo } = useRedirect();
  const [sponsorLogo, setSponserLogo] = useState([]);
  const [showVideo, setShowVideo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [videoRendered, setVideoRendered] = useState(false);
  const [clVideoref, inView] = useInView({
    fallbackInView: false,
    threshold: 0
  });
  const videoDetailsParent = useRef();
  const [aspectVideoContainerSize, setAspectVideoContainerSize] = useState('0px');
  const playerRef = useRef();
  const onReady = React.useCallback(() => {
    if (data?.play_time) {
      //console.log('===>>', data?.play_time);
      const timeToStart = data?.play_time;
      playerRef.current.seekTo(timeToStart, 'seconds');
    }
  }, [playerRef.current]);
  const cardClick = () =>
    click ? click() : redirectTo('ClinicalVideoDetails', data.type_id, data.question);
  const setVideoConatinerSize = () => {
    if (videoDetailsParent.current) {
      const videoDivWidth = videoDetailsParent.current ? videoDetailsParent.current.clientWidth : 0;
      const aspectWidth = videoDivWidth / 1.7786;
      setAspectVideoContainerSize(aspectWidth > 0 ? Math.round(aspectWidth) : 0);
      // console.log('aspect size is ' + Math.round(aspectWidth));
    }
  };
  useEffect(() => {
    setVideoConatinerSize();
    //console.log('SET CONTAINER');
    if (data?.sponsor_logo) {
      setSponserLogo(data?.sponsor_logo.split(','));
    }
  }, [tabKey]);
  const handleVideoShow = () => {
    setLoading(true);
    setShowVideo(true);
    setTimeout(() => {
      setShowVideo(false);
      setVideoRendered(false);
    }, 30000);
  };
  const handleVideoClose = () => {
    setShowVideo(false);
    setLoading(false);
    setVideoRendered(false);
  };
  useEffect(() => {
    if (isMobile && !inView) {
      handleVideoClose();
    }
  }, [inView]);
  function format(seconds) {
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = pad(date.getUTCMinutes());
    const ss = pad(date.getUTCSeconds());
    if (hh) {
      return `${hh}:${mm}:${ss}`;
    }
    return `${mm}:${ss}`;
  }

  function pad(string) {
    return ('0' + string).slice(-2);
  }
  const handleStart = () => {
    setLoading(false);
    setVideoRendered(true);
  };
  const shareClick = () => { };
  const location = useLocation();
  const isToNavigateSpeciality = (location, id) => {
    const { search, pathname } = location;
    return !(search.includes(id.toString()) && pathname.includes('/Speciality'));
  };
  const { userActivityTracker } = useTrackUserActivity();
  return (
    <InView
      as="div"
      onChange={(inView) => {
        userActivityTracker(inView, { ...data, type: 'archived_video' }, 'card');
      }}
    >
      <div
        className="w-100 float-start clVideoCardV1Box bg-white shadow rounded-3 position-relative overflow-hidden"
        ref={clVideoref}
      >
        <span
          className="graph-1 position-absolute start-0 bottom-0"
          style={{ backgroundColor: data?.color ?? '#34caf5' }}
        ></span>
        <span
          className="graph-2 position-absolute start-0 bottom-0"
          style={{ backgroundColor: data?.color ?? '#34caf5' }}
        ></span>
        {!hideImage && (
          <div
            className="w-100 float-start clVideoCardV1BoxPic cursorPointer cmnVideoBoxContainer position-relative overflow-hidden"
            ref={videoDetailsParent}
            style={{ height: `${aspectVideoContainerSize}px` }}
            onMouseEnter={handleVideoShow}
            onMouseLeave={handleVideoClose}
            onTouchMove={handleVideoShow}
          >
            {/* {!showVideo && (
            <div className="rounded-circle d-inline-flex align-items-center justify-content-center clVideoCardV1PlayIcon  position-absolute top-50 start-50 translate-middle z-3 bg-white bg-opacity-75 cursorPointer">
              <svg className="text-primary fs-2" strokeWidth="0" viewBox="0 0 448 512">
                <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
              </svg>
            </div>
          )}
          {loading && (
            <div className="rounded-circle d-inline-flex align-items-center justify-content-center clVideoCardV1Load position-absolute top-50 start-50 translate-middle z-3 cursorPointer">
              <Spinner animation="border" />
            </div>
          )} */}
            {!showVideo && (
              <>
                {sponsorLogo.length == 1 && (
                  <div className="crdV1sponser position-absolute rounded m-0 text-center bg-white">
                    <div className="crdV1sponserIn position-relative bg-white w-100">
                      <LazyImage
                        src={sponsorLogo[0]}
                        className="position-absolute start-50 top-50 translate-middle mw-100 mh-100 w-auto h-auto"
                        alt="sponsor logo"
                        logo
                      />
                    </div>
                  </div>
                )}

                {/* sponser logo if multiple */}
                {sponsorLogo?.length > 1 && (
                  <Swiper
                    className="crdV1sponser position-absolute rounded m-0 text-center bg-white"
                    navigation={false}
                    spaceBetween={0}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{
                      delay: 2500
                    }}
                    effect={'fade'}
                  >
                    {sponsorLogo?.map((logo, index) => {
                      return (
                        <SwiperSlide
                          className="crdV1sponserIn position-relative bg-white w-100"
                          key={index + 1}
                        >
                          <LazyImage
                            src={logo}
                            className="position-absolute start-50 top-50 translate-middle mw-100 mh-100 w-auto h-auto"
                            alt="sponsor logo"
                            logo
                          />
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                )}
              </>
            )}

            {showVideo ? (
              <div className="w-100 h-100 cmnVideosDbV2Video">
                <ReactPlayer
                  ref={playerRef}
                  onReady={onReady}
                  onStart={handleStart}
                  url={data?.src}
                  playing={true}
                  controls={false}
                  width={'100%'}
                  height={'100%'}
                  muted={true}
                  playsinline={true}
                />
              </div>
            ) : null}

            <LazyImage
              src={data?.image ?? clinical_Video_static_image}
              alt="video"
              className="object-fit-cover h-100 w-100 float-start"
              fallback_image={clinical_Video_static_image}
            />
            <div
              className={`overlay cursorPointer d-flex align-items-center justify-content-center ${loading ? 'dbClLoading' : ''
                }${videoRendered ? 'dbClAfterLoading' : ''} gtm_cl_clinicalVideoCard`}
            >
              {/* {!showVideo && <RiPlayCircleFill customClass="text-white fs-72" />} */}
              {/* {loading && <img src={_cl.image} className="object-fit-cover h-100 w-100 float-start" />} */}
              <RiPlayCircleFill customClass="text-white fs-72 position-absolute top-50 start-50 translate-middle" />
              <Spinner animation="border" />
            </div>
            <div
              className={`w-100 h-100 cmnVideosTrigr cursorPointer gtm_cl_clinicalVideoCard`}
              onClick={cardClick}
            ></div>

            {data?.duration && (
              <span className="text-white fs-4 clVideoCardV1Time rounded position-absolute z-3 bg-black bg-opacity-75 py-1 px-2">
                {format(data?.duration)}
              </span>
            )}
            {loading && !isMobile && (
              <span className="text-white fs-4 clVideoCardV1Keep rounded position-absolute z-3 bg-black bg-opacity-75 py-1 px-2">
                Keep hovering to preview
              </span>
            )}

            {data?.duration &&
              data?.play_time &&
              (parseInt(data?.play_time) / parseInt(data?.duration)) * 100 > 0 && (
                <ProgressBar now={(parseInt(data?.play_time) / parseInt(data?.duration)) * 100} />
              )}
          </div>
        )}
        <div className="w-100 float-start clVideoCrdV1Btm p-4 ps-0">
          <div className="crdV1topPart d-flex align-items-center justify-content-between position-relative ps-4 mb-2">
            <span
              className="crdV1topPartGraph position-absolute start-0 top-50 translate-middle-y"
              style={{ backgroundColor: data?.color ?? '#34caf5' }}
            ></span>
            <div className="text-black crdV1Speclty d-flex gap-2">
              <span
                className={`fs-4 ${hideImage === true ? '' : 'cursorPointer'
                  } gtm_cl_clinicalVideoCard_specialities`}
                onClick={() => {
                  if (data?.specialities_ids_and_names) {
                    isToNavigateSpeciality(location, data?.specialities_ids_and_names[0]?.id) &&
                      redirectTo(
                        'Speciality',
                        data?.specialities_ids_and_names[0]?.id,
                        data?.specialities_ids_and_names[0]?.name
                      );
                  }
                }}
              >
                {/* {data?.specialities?.split(',')[0]} */}
                {data?.specialities_ids_and_names &&
                  data?.specialities_ids_and_names.length > 0 &&
                  data?.specialities_ids_and_names[0].name}
              </span>
              {specialityPopOver(
                data?.specialities_ids_and_names &&
                data?.specialities_ids_and_names.length > 0 &&
                data?.specialities_ids_and_names?.map((speciality) => speciality.name).join(',')
              )}
            </div>
            <a href="javascript:void(0)" className="cardV1DotsMenu text-black">
              <ShareCard
                shareClick={shareClick}
                data={{ title: data?.question, url: data?.deeplink }}
                // id={`${gtmTagVariable}_clinicalVideoCard_${data.type_id}`}
                gtmTagVariable={`gtm_cl_clinicalVideoCard_share`}
              />
            </a>
          </div>
          <div
            className="d-flex text-start cardV1Topic cursorPointer ps-4 mb-2"
            onClick={cardClick}
          >
            <h2
              className={`text-black fs-16 fw-medium text-break line-clamp-3 gtm_cl_clinicalVideoCard text-break`}
            // id={`${gtmTagVariable}_clinicalVideoCard_question_${data.type_id}`}
            >
              {reactHtmlParser(data?.question)}
            </h2>
          </div>

          <div className="w-100 float-start cardV1Ftr d-flex align-items-center justify-content-between mt-2 cursorPointer">
            <DoctorsSectionForCard
              gtmTagVariable={`gtm_cl_clinicalVideoCard`}
              type={'clVideo'}
              // id={data?.type_id}
              cardData={data}
            />
          </div>
        </div>
      </div>
    </InView>
  );
};
export default memo(ClinicalVideoCardV1);
